import Debug from "../../../core/debug"
import Storage from "../../storage"

/**
 * The available streaming protocols.
 * 
 * @author Stan Hurks
 */
export type StreamingProtocol = 'dash' | 'dash_u' | 'hls' | 'progressive' | 'smooth' | 'auto'

/**
 * Represents all `Storage` data related to the video source
 * used in the player.
 * 
 * @author Stan Hurks
*/
export default class StorageDataModelSource {

    /**
     * The title of the video source
     */
    public title: string = Debug.initialized 
        ? 'Nederland Zingt' 
        : ''

    /**
     * The description of the video source
     */
    public description: string = Debug.initialized
        ? 'In de Sint-Joriskerk van Amersfoort zingen Maria den Hertog, Tamara Ester, Teun van Dijk en Aart van der Snoek van het klassiek ensemble Cantus Lux Aeterna liederen uit het Liedboek. Hun gezang wordt ondersteund door samenzang.'
        : ''

    /**
     * The protocol
     */
    public protocol: StreamingProtocol = 'auto'

    /**
     * Optional: Load a dash file from a Product ID (aka: "PRID").
     */
    public prid: string = ''

    /**
     * The URL to the thumbnail track .vtt file
     */
    public thumbnailTrackURL: string = 'https://dev-tommie.cdn.streamgate.nl/static/npo/VPWON_1336240_v1642267319.vtt'

    /**
     * The URL to the poster
     */
    public poster: string = 'https://images.npo.nl/header/2560x1440/1658721.jpg'

    /**
     * The URL to the subtitle .vtt file
     */
    public subtitleURL: string = 'https://dev-tommie.cdn.streamgate.nl/static/npo/VPWON_1336240_ORG.vtt'

    /**
     * Reset the data to defaults
     */
    public static reset = () => {
        const defaultInstance = new StorageDataModelSource()

        for (const property of Object.keys(defaultInstance)) {
            const value = (defaultInstance as any)[property] as any

            (Storage.data.source as any)[property] = value
        }
    }
}